
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_30w8x_153",
  "tools": "awsui_tools_wih1l_30w8x_164",
  "tools-filtering": "awsui_tools-filtering_wih1l_30w8x_172",
  "tools-align-right": "awsui_tools-align-right_wih1l_30w8x_186",
  "tools-pagination": "awsui_tools-pagination_wih1l_30w8x_190",
  "tools-preferences": "awsui_tools-preferences_wih1l_30w8x_190",
  "tools-small": "awsui_tools-small_wih1l_30w8x_196",
  "table": "awsui_table_wih1l_30w8x_202",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_30w8x_209",
  "wrapper": "awsui_wrapper_wih1l_30w8x_213",
  "variant-stacked": "awsui_variant-stacked_wih1l_30w8x_220",
  "wrapper-content-measure": "awsui_wrapper-content-measure_wih1l_30w8x_220",
  "variant-container": "awsui_variant-container_wih1l_30w8x_220",
  "has-footer": "awsui_has-footer_wih1l_30w8x_223",
  "has-header": "awsui_has-header_wih1l_30w8x_226",
  "cell-merged": "awsui_cell-merged_wih1l_30w8x_243",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_30w8x_255",
  "empty": "awsui_empty_wih1l_30w8x_271",
  "loading": "awsui_loading_wih1l_30w8x_275",
  "selection-control": "awsui_selection-control_wih1l_30w8x_284",
  "selection-control-header": "awsui_selection-control-header_wih1l_30w8x_291",
  "header-secondary": "awsui_header-secondary_wih1l_30w8x_297",
  "variant-full-page": "awsui_variant-full-page_wih1l_30w8x_309",
  "table-has-header": "awsui_table-has-header_wih1l_30w8x_315",
  "header-controls": "awsui_header-controls_wih1l_30w8x_326",
  "variant-embedded": "awsui_variant-embedded_wih1l_30w8x_335",
  "variant-borderless": "awsui_variant-borderless_wih1l_30w8x_335",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_30w8x_340",
  "footer": "awsui_footer_wih1l_30w8x_340",
  "footer-with-pagination": "awsui_footer-with-pagination_wih1l_30w8x_348",
  "footer-pagination": "awsui_footer-pagination_wih1l_30w8x_356",
  "thead-active": "awsui_thead-active_wih1l_30w8x_360",
  "row": "awsui_row_wih1l_30w8x_361",
  "row-selected": "awsui_row-selected_wih1l_30w8x_362"
};
  